window.addEventListener("load", function () {
    loadCmsAssets();
});

/* LOAD ASSETS */

let assetsLoaded = false;
function loadCmsAssets() {
    if (assetsLoaded) {
        return null;
    }

    // загружаем только если есть кнопки админские
    if (!document.querySelector(".cms-actions button")) {
        return null;
    }

    let link, script, subscript;

    link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/admin/assets/css/adminpanel/admin.css";
    document.head.appendChild(link);

    // тут надо сначала jquery загрузить, потом админские скрипты
    script = document.createElement("script");
    script.type = "text/javascript";
    document.body.appendChild(script);
    script.onload = function () {
        subscript = document.createElement("script");
        subscript.type = "text/javascript";
        subscript.src = "/admin/assets/js/adminpanel/admin.js";
        document.body.appendChild(subscript);

        assetsLoaded = true;
    };
    // в самом конце указываем src, т.к. он сразу начнет загрузку
    script.src = "/admin/assets/js/jquery-3.6.0.min.js";
}
